import script from "./noticeDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./noticeDetail.vue?vue&type=script&setup=true&lang=js"

import "./noticeDetail.vue?vue&type=style&index=0&id=466ee9d0&lang=scss&scoped=true"
import "./noticeDetail.vue?vue&type=style&index=1&id=466ee9d0&lang=scss"
import "./noticeDetail.vue?vue&type=style&index=2&id=466ee9d0&lang=css"

import exportComponent from "/root/workspace/public_sso_ZgiA/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-466ee9d0"]])

export default __exports__